export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.7.0';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@sentry/browser/esm/version.js
// module id = QJF9
// module chunks = 19